/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import EstatePhoto from './EstatePhoto'
import { useQuery } from '@tanstack/react-query'
import { fetchEstate } from '../../lib/rest/estateAPIClient'
import { useMemo } from 'react'
import Ref from '../Ref'
import { getEstateLink } from '../../lib/links/estateLinks'
import { Box, Card, CardProps, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import Amount from '../transaction/Amount'

export type EstateInfoCardProps = CardProps & {
  estateId: number
}

function EstateInfoCard (props: EstateInfoCardProps) {
  const { children, estateId, ...others } = props

  const estateQuery = useQuery({
    enabled: estateId > 0,
    queryKey: ['estate', estateId],
    queryFn: () => fetchEstate(estateId),
    refetchOnWindowFocus: false
  })

  const estate = estateQuery.data
  const photos = useMemo(() => estate?.Photos || [], [estate?.Photos])

  return (
    <Card withBorder shadow="none" {...others}>
      <Card.Section bg="gray.0">
        <EstatePhoto
          height={150}
          photos={photos}
        />
      </Card.Section>
      <Stack gap="xs" mt="sm" style={{ flexGrow: 1 }}>
        <Box ta="center" fz="sm">
          <AnchorLink to={getEstateLink(estateId)}>
            <Ref span value={estate?.reference} />
          </AnchorLink>
          <Text inherit>{estate?.title}</Text>
          <Amount inherit value={estate?.price} withCurrency />
        </Box>
        {children}
      </Stack>
    </Card>
  )
}

export default EstateInfoCard
